import { HttpContext, HttpContextToken } from "@angular/common/http";

export const BYPASS_ACCESS_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export function skipAccessInterceptor(): HttpContext {
  return new HttpContext().set(BYPASS_ACCESS_INTERCEPTOR, true);
}